import { render, staticRenderFns } from "./SentNotification.vue?vue&type=template&id=38a954d3&"
import script from "./SentNotification.vue?vue&type=script&lang=js&"
export * from "./SentNotification.vue?vue&type=script&lang=js&"
import style0 from "./SentNotification.vue?vue&type=style&index=0&id=38a954d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports